import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';

import './radio_group.scss';

const CLASS_NAME = 'radio-group';

const onRadioValueChange = (selection, callback) => () => {
  if (_.isFunction(callback)) {
    callback(selection);
  }
};

const RadioGroup = ({ options, onValueChange, value }) =>
  _.map(options, (item, index) => {
    const { label, value: itemValue } = item;
    const inputId = `radio-${label}`;
    return (
      <div
        className={classnames(`${CLASS_NAME}__radio`, {
          [`${CLASS_NAME}__radio--with-spacing`]: !_.isEqual(index, _.size(options) - 1),
        })}
        key={`radio-group-item-${index}`}
      >
        <input
          checked={_.isEqual(itemValue, value)}
          className={`${CLASS_NAME}__radio-button`}
          id={inputId}
          onChange={onRadioValueChange(itemValue, onValueChange)}
          type="radio"
        />
        <label className={`${CLASS_NAME}__radio-button-label`} htmlFor={inputId} />
        <div className={`${CLASS_NAME}__radio-content`}>
          <p className={`${CLASS_NAME}__radio-title`}>{label}</p>
        </div>
      </div>
    );
  });

RadioGroup.propTypes = {
  onValueChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
    }),
  ),
  value: PropTypes.any,
};

export default RadioGroup;
